class CookieConsent {
  constructor() {
    // Don't show if user has already made a choice
    if (this._hasConsented()) return;

    // Wait 3 s after page reveal, then show the popup
    setTimeout(() => this._show(), 3000);
  }

  _hasConsented() {
    if (typeof window.getCkyConsent === 'function') {
      return !!window.getCkyConsent()?.isUserActionCompleted;
    }
    const match = document.cookie.match(/cookieyes-consent=([^;]+)/);
    return match ? decodeURIComponent(match[1]).includes('action:yes') : false;
  }

  _show() {
    // Re-check in case CookieYes resolved consent during the 3 s delay
    if (this._hasConsented()) return;

    const popup    = document.querySelector('.cookie-consent');
    const btnAccept    = document.querySelector('.cookie-consent__accept');
    const btnDecline   = document.querySelector('.cookie-consent__decline');
    const btnCustomize = document.querySelector('.cookie-consent__customize');

    if (!popup) return;

    popup.removeAttribute('aria-hidden');
    popup.classList.add('is-visible');

    const hide = () => {
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
    };

    // Listen for CookieYes consent resolution
    const onConsent = () => {
      document.removeEventListener('cookieyes_consent_update', onConsent);
      hide();
    };
    document.addEventListener('cookieyes_consent_update', onConsent);

    // Accept — delegate to CookieYes hidden button, fallback to hide
    btnAccept?.addEventListener('click', () => {
      const ckyAccept = document.querySelector('[data-cky-tag="accept-button"]');
      if (ckyAccept) {
        ckyAccept.click();
      } else {
        hide();
      }
    });

    // Decline — delegate to CookieYes reject button, fallback to hide
    btnDecline?.addEventListener('click', () => {
      const ckyReject = document.querySelector('[data-cky-tag="reject-button"]');
      if (ckyReject) {
        ckyReject.click();
      } else {
        hide();
      }
    });

    // Customize — open CookieYes preference center
    btnCustomize?.addEventListener('click', () => {
      document.querySelector('[data-cky-tag="settings-button"]')?.click();
    });
  }
}

export { CookieConsent };
